import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";


// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import IntroductionFirstItem from './layout/hero/IntroductionFirstItem';
import Introduction from './layout/hero/Introduction';
import WarpLarge from './layout/warp/WarpLarge';
import metaTageImage from './img/personalProject/nightCity-poster-001@2x.png';


const metatag = {
  title: "Home ✴︎ Jinju Jang",
  author: "Jinju Jang",
  url: "http://jinju.io/",
  description:"Product/UX Designer based in Melbourne.",
  image: "http://jinju.io" + metaTageImage,
}

class App extends Component {
  render() {
    return (
      <div>
        <Helmet>
           <meta charSet="utf-8"/>
           <meta name="author" content="Jinju Jang"/>
           <meta name="description" content={metatag.description} data-react-helmet="true" />

           {/*-- Google / Search Engine Tags --*/}
           <meta itemprop="name" content={metatag.title}  data-react-helmet="true" />
           <meta itemprop="description" content={metatag.description}  data-react-helmet="true" />
           <meta itemprop="image" content={metatag.image}  data-react-helmet="true" />

           {/*-- Open Graph / Facebook --*/}
           <meta property="og:url" content={metatag.url}  data-react-helmet="true" />
           <meta property="og:type" content="website"  data-react-helmet="true" />
           <meta property="og:title" content={metatag.title}  data-react-helmet="true" />
           <meta property="og:description" content={metatag.description} data-react-helmet="true" />
           <meta property="og:image" content={metatag.image} data-react-helmet="true" />

           {/*-- Twitter --*/}
           <meta name="twitter:card" content="summary_large_image" data-react-helmet="true" />
           <meta name="twitter:title" content={metatag.title} data-react-helmet="true" />
           <meta name="twitter:description" content={metatag.description} data-react-helmet="true" />
           <meta name="twitter:image" content={metatag.image} data-react-helmet="true" />
          <title>{metatag.title}</title>

        </Helmet>
        <Navigation />
        <IntroductionFirstItem/>
        <Introduction />
        <WarpLarge/>
        <Footer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js